import { AppProvider } from "@contexts/AppContext";
import {
  AuthenticatedApiProvider,
  BaseApiProvider,
} from "@contexts/ApiContext";
import { AuthProvider } from "@contexts/AuthContext";
import { PreferenceProvider } from "@contexts/PreferenceContext";
import { StorageProvider } from "@contexts/StorageContext";
import { ThemeProvider } from "@repo/ui/provider";
// after the provider so portal overrides win over Mantine/base styles
import { naPortalTheme } from "@repo/ui/na";
import { PostHogProvider } from "./analytics";
import AppRouter from "./AppRouter";
import { MonitoringInit } from "./monitoring/MonitoringInit";

function App() {
  return (
    <ThemeProvider theme={naPortalTheme}>
      <StorageProvider namespace="root">
        <PreferenceProvider>
          <BaseApiProvider>
            <AppProvider>
              <MonitoringInit />
              <AuthProvider>
                <AuthenticatedApiProvider>
                  <PostHogProvider>
                    <AppRouter />
                  </PostHogProvider>
                </AuthenticatedApiProvider>
              </AuthProvider>
            </AppProvider>
          </BaseApiProvider>
        </PreferenceProvider>
      </StorageProvider>
    </ThemeProvider>
  );
}

export default App;
